<!--
component: ListEst
author: Ken Nakamura
description: 同一物件概要書リスト
-->
<template>
  <section class="list">
    <v-container fluid>
      <v-row class="mb-1">
        <v-col :cols="topButtonVisible ? 10 : 12" class="pa-0">
          <h2 style="text-align: center; margin: 0.5em;">
            {{ contentsTitle }}
          </h2>
          <h3 v-show="$vuetify.breakpoint.name!='xs'" style="text-align: center; margin: 0.5em;">
            {{ contentsMessage }}
          </h3>
          <h4 v-show="$vuetify.breakpoint.name=='xs'" style="text-align: center; margin: 0.5em;">
            {{ contentsMessage }}
          </h4>
          <h4 v-show="$vuetify.breakpoint.name!='xs'" style="text-align: center; margin: 0.5em;">
            {{ subMessage }}
          </h4>
          <h5 v-show="$vuetify.breakpoint.name=='xs'" style="text-align: center; margin: 0.5em;">
            {{ subMessage }}
          </h5>
        </v-col>
        <v-col style="position: relative;"
          v-show="topButtonVisible">
          <v-btn absolute top right x-large
            @click="browse" :disabled="!isSelected || loading" :loading="loading">
            {{ browseButtonTitle }}
          </v-btn>
        </v-col>
      </v-row>
      <ListEstate />
      <v-row class="mt-1">
        <v-col class="py-0" style="position: relative;">
          <v-btn absolute top right x-large
            v-show="bottomButtonVisible"
            @click="browse" :disabled="!isSelected || loading" :loading="loading">
            {{ browseButtonTitle }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import ListEstate from '../components/ListEstate.vue'
import { dbglog } from '../common/utils.js'

export default {
  components: {
    ListEstate,
  },
  data: () => {
    return {
      loading: false,
      isSelected: false,
    }
  },
  props: {
    listId: {
      type: Number,
      default: 0,
    },
    topButtonVisible: {
      type: Boolean,
      default: false,
    },
    bottomButtonVisible: {
      type: Boolean,
      default: true,
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 6);
    this.setMessage();
    this.isSelected = (this.gaiyoId != null && this.gaiyoId.length > 0);
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    mode () {
      return this.$store.state.mode;
    },
    contentsTitle () {
      return '物件検索結果';
    },
    contentsMessage () {
      return '同一物件の元確認、変更申請が存在します。';
    },
    subMessage () {
      return `閲覧したい概要書をタッチして選択し、[${this.browseButtonTitle}]ボタンを押してください。`;
    },
    kenkaku () {
      //return this.$store.state.summaries;
      return this.$store.state.gaiyoList;
    },
    gaiyoId () {
      return this.$store.state.gaiyoId;
    },
    ukeNo () {
      return this.$store.state.ukeNo;
    },
    gaiyo () {
      return this.$store.state.gaiyoData;
    },
    browseButtonTitle() {
      return '概要書を閲覧';
    },
    /*
    isSelected() {
      //return this.selectedNo == null || this.selectedNo.length == 0;
      return true;
    },
    */
    wardCode() {
      return this.$store.state.wardCode;
    },
    wardName() {
      return this.$store.state.wardName;
    },
    townCode() {
      return this.$store.state.townCode;
    },
    townName() {
      return this.$store.state.townName;
    },
    oyaban() {
      return this.$store.state.oyaban;
    },
    edaban() {
      return this.$store.state.edaban;
    },
  },
  watch: {
    gaiyoId (newValue, oldValue) {
      dbglog(`ListEst: gaiyoId.features(${newValue},${oldValue})`);
      if (newValue != null && newValue.length > 0) {
        this.isSelected = true;
      }
    }
  },
  methods: {
    /**
     * AppFooterに表示するメッセージを生成・登録する
     */
    setMessage () {
      const count = this.kenkaku.length;
      this.message = `検索結果：${count}件`;
    },
    /**
     * 現在選択されている概要書を表示する
     */
    browse () {
      dbglog(`ListEst.browse(${this.gaiyoId})`);
      this.$router.push({ name: 'loading', params: { action: 4 }});
    },
  }
}
</script>

<style lang="scss">
@import '../styles/common/common.css';
@import '../styles/table-styles.css';

.active {
  display: block;
}
.inactive {
  display: none;
}
</style>